const state = {

   
    selObFlight:null,
    selIbFlight:null,
    orgBindedFlightLs:null,
    selObSortValue: null,
    selIbSortValue: null,
    searchPricingReq: null,
    searchRes: null,
    selectedPricingObj: null,
    selFlightObjFrmPric: null,
    airlines: null,
    airports:null,
    currencyObj: null,
    BindedFlightLs:null,
    obFilterData:null,
    ibFilterData:null,
    ibDispfilterLs:[],
    obDispfilterLs:[],
    cheapestLs:[],
    selPriceForFooter:null
};

const getters = {
    GET_ORG_BINDED_FLIGHT_LS: (state) => {
        return state.orgBindedFlightLs;
    },
    
    GET_OB_FILTER_DATA: (state) => {
        return state.obFilterData;
    },
    GET_IB_FILTER_DATA: (state) => {
        return state.ibFilterData;
    },
    GET_OB_FLIGHT_OBJ: (state) => {
        return state.selObFlight;
    },
    GET_IB_FLIGHT_OBJ: (state) => {
        return state.selIbFlight;
    },
    GET_OB_SEL_SORT_VALUE: (state) => {
        return state.selObSortValue;
    },
    GET_IB_SEL_SORT_VALUE: (state) => {
        return state.selIbSortValue;
    },
    GET_SEL_PRICING_OBJ: (state) => {
        return state.selectedPricingObj;
    },
    GET_SEL_FLI_FRM_PRIC: (state) => {
        return state.selFlightObjFrmPric;
    },
    GET_AIRLINES: (state) => {
        return state.airlines;
    },
    GET_AIRPORTS: (state) => {
        return state.airports;
    },
    GET_CURRENCY: (state) => {
        return state.currencyObj;
    },

    GET_SEARCH_PRICING_REQ: (state) => {
        return state.searchPricingReq;
    },
    GET_SEARCH_RES: (state) => {
        return state.searchRes;
    },
    GET_BINDED_FLIGHT_LS: (state) => {
        return state.BindedFlightLs;
    },
    GET_OB_DISP_FILTER_LS: (state) => {
        return state.obdispfilterLs;
    },
    GET_IB_DISP_FILTER_LS: (state) => {
        return state.ibdispfilterLs;
    },
    GET_CHEAPEST_LS: (state) => {
        return state.cheapestLs;
    },
    GET_SELFLIGHT_FOR_FOOTER: (state) => {
        return state.selPriceForFooter;
    }



};


const actions = {
    
    SET_ORG_BINDED_FLIGHT_LS: ({ commit }, orgBindedFlightLs) => {
        commit('saveOrgBindedFlightLs', orgBindedFlightLs)
    },

    CLEAR_RESULT_STORE: ({ commit }) => {
        commit('clearResultStore');
    },
    SET_CHEAPESTLS: ({ commit }, cheapestLs) => {

        commit('saveCheapestLs', cheapestLs);

    },
    SET_SELFLIGHT_FOR_FOOTER: ({ commit }, pric) => {

        commit('saveSelPricForFooter', pric);

    },

    SET_AIRLINES: ({ commit }, airlines) => {

        commit('saveAirLines', airlines);

    },
    SET_AIRPORTS: ({ commit }, airports) => {

        commit('saveAirPorts', airports);

    },
    SET_CURRENCY: ({ commit }, currency) => {

        commit('saveCurrencyObj', currency);

    },

    
    SET_OB_FILTER_DATA: ({ commit }, filters) => {

        commit('saveobFilterData', filters);

    },
    SET_IB_FILTER_DATA: ({ commit }, filters) => {

        commit('saveibFilterData', filters);

    },
    SET_OB_FLIGHT_OBJ: ({ commit }, selObFlight) => {

        commit('saveObSelFlightObj', selObFlight);

    },
    SET_IB_FLIGHT_OBJ: ({ commit }, selIbFlight) => {

        commit('saveIbSelFlightObj', selIbFlight);

    },
    SET_OB_SEL_SORT_OBJ: ({ commit }, selObSort) => {

        commit('saveselObSortObj', selObSort);

    },
    SET_IB_SEL_SORT_OBJ: ({ commit }, selIbSort) => {

        commit('saveselIbSortObj', selIbSort);

    },
    SET_SEL_PRICING_OBJ: ({ commit }, selectedPricing) => {

        commit('saveSelectedPricing', selectedPricing);

    },
    SET_SEL_FLI_FRM_PRIC: ({ commit }, selFlightFrmPric) => {

        commit('saveSelFliFrmPric', selFlightFrmPric);

    },

    SET_SEARCH_PRICING_REQ: ({ commit }, searchPricingReq) => {
        commit('saveSearchPricingReq', searchPricingReq)
    },

    SET_SEARCH_RES: ({ commit }, searchRes) => {
        commit('saveSearchRes', searchRes)
    },
    SET_BINDED_FLIGHT_LS: ({ commit }, BindedFlightLs) => {
        commit('saveBindedFlightLs', BindedFlightLs)
    },
    SET_OB_DISP_FILTER_LS: ({ commit }, obdispfilterLs) => {
        commit('saveobDisplayFilterLs', obdispfilterLs)
    },
    SET_IB_DISP_FILTER_LS: ({ commit }, ibdispfilterLs) => {
        commit('saveibDisplayFilterLs', ibdispfilterLs)
    }



};


const mutations = {
    clearResultStore: (state) => {
        state.orgBindedFlightLs=null;
        state.cheapestLs=[];
        state.selObFlight = null;
        state.selIbFlight = null;
        state.selObSortValue = null;
        state.selIbSortValue = null;
        state.selectedPricingObj = null;
        state.selFlightObjFrmPric = null;
        state.searchPricingReq = null;
        state.searchRes = null;
        state.BindedFlightLs=null;
        state.obFilterData=null;
        state.ibFilterData=null;
        state.obdispfilterLs=null;
        state.ibdispfilterLs=null;
        state.airlines=null;
        state.airports=null;
        state.currencyObj=null;
    },
    saveOrgBindedFlightLs: (state, orgBindedFlightLs) => {
        state.orgBindedFlightLs = orgBindedFlightLs;
    },

    saveCheapestLs: (state, cheapestLs) => {
        state.cheapestLs = cheapestLs;
    },
    saveobFilterData: (state, obFilterData) => {
        state.obFilterData = obFilterData;
    },
    saveibFilterData: (state, ibFilterData) => {
        state.ibFilterData = ibFilterData;
    },
    saveBindedFlightLs: (state, BindedFlightLs) => {
        state.BindedFlightLs = BindedFlightLs;
    },
    saveobDisplayFilterLs: (state, obdispfilterLs) => {
        state.obdispfilterLs = obdispfilterLs;
    },
    saveibDisplayFilterLs: (state, ibdispfilterLs) => {
        state.ibdispfilterLs = ibdispfilterLs;
    },
    saveCurrencyObj: (state, currencyObj) => {
        state.currencyObj = currencyObj;
    },
    saveAirLines: (state, airlines) => {
        state.airlines = airlines;
    },
    saveAirPorts: (state, airports) => {
        state.airports = airports;
    },
    
    saveObSelFlightObj: (state, selObFlight) => {
        state.selObFlight = selObFlight;

    },
    saveIbSelFlightObj: (state, selIbFlight) => {
        state.selIbFlight = selIbFlight;

    },
    saveselObSortObj: (state, selSort) => {

        state.selObSortValue = selSort;
    },
    saveselIbSortObj: (state, selSort) => {

        state.selIbSortValue = selSort;
    },
    saveSelectedPricing: (state, selectedPricing) => {
        state.selectedPricingObj = selectedPricing;
    },
    saveSelFliFrmPric: (state, selFlightFrmPric) => {
        state.selFlightObjFrmPric = selFlightFrmPric;
    },


    saveSearchPricingReq: (state, searchPricingRequest) => {
        state.searchPricingReq = searchPricingRequest;
    },
    saveSearchRes: (state, searchRes) => {
        state.searchRes = searchRes;
    },
    
    saveSelPricForFooter: (state, pric) => {
        state.selPriceForFooter = pric;
    },

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}